import { z, ZodObject } from 'zod';
import { getSchema, TableQuerySchemaType } from './helpers';

type TableSchemaOptions = {
  tableIds?: readonly string[];
  defaultPageSize?: number;
  minPage?: number;
  maxPageSize?: number;
  minPageSize?: number;
};

type NoTableIdShape = {
  page: z.ZodOptional<z.ZodCatch<z.ZodNumber>>;
  pageSize: z.ZodOptional<z.ZodCatch<z.ZodNumber>>;
  sort: z.ZodOptional<z.ZodString>;
  search: z.ZodOptional<z.ZodString>;
};

export function createTableQuerySchema(options?: {
  tableIds?: readonly [];
  defaultPageSize?: number;
  minPage?: number;
  maxPageSize?: number;
  minPageSize?: number;
}): ZodObject<NoTableIdShape>;
export function createTableQuerySchema(
  options: TableSchemaOptions
): ZodObject<TableQuerySchemaType>;
export function createTableQuerySchema(
  options?: TableSchemaOptions
): ZodObject<TableQuerySchemaType> {
  const {
    tableIds = [],
    defaultPageSize,
    minPage,
    maxPageSize,
    minPageSize,
  } = options ?? {};
  const schemaObject: TableQuerySchemaType = {};
  const ids: (string | undefined)[] = tableIds.length
    ? [...tableIds]
    : [undefined];

  ids.forEach((tableId) =>
    getSchema({
      schemaObject,
      tableId,
      defaultPageSize,
      minPage,
      maxPageSize,
      minPageSize,
    })
  );

  return z.object(schemaObject);
}
